import React from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses } from '../../lib/ep';

// We use this to simply display a SectionTitle without any extra HTML item or translation
// (mostly used to display ENG / SPA texts that are not in the labels platform):
export const SectionSubtitleSimple = (props) => {
	let classname = props?.classname ?? 'wizard_section_subtitle';
	classname = parseClasses(classname, props._class, 'subtitle');

	return (
		<div class={classname}>
			<p class="gui_inline_block">{props.children}</p>
		</div>
	);
};

const SectionSubtitle = (props) => {
	const autotranslate = props?.autotranslate ?? true;
	const children_text = (autotranslate && props.children != undefined) ? props.intl.formatMessage({id:props.children}) : props.children;

	let classname = props?.classname ?? 'wizard_section_subtitle';
	classname = parseClasses(classname, props._class, 'subtitle');

	return (
		<div class={classname}>
			{(typeof children_text  == 'object') ? (
				<p class="gui_inline_block">{children_text}</p>
			) : (
				<p class="gui_inline_block" dangerouslySetInnerHTML={{ __html:(children_text) ? children_text.replace(/\n/g, '<br />') : '' }}></p>
			)}

			{(props.tooltip != undefined) && (
				props.tooltip
			)}
		</div>
	);
}

export default injectIntl(SectionSubtitle);